import { Footer } from '../../components/Footer/Footer';
import { AppShell } from '../../components/AppShell/AppShell';
import { CourseBox } from '../../components/CourseBox/CourseBox';
import { HighlightedCard } from '../../components/HighlightedCard/HighlightedCard';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import { useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import styles from './Courses.module.scss';

const CoursesComponent = () => {
  const { t } = useTranslation();
  const { courses, getCourses, userCompanyData } = useFirebase();
  const { id } = useParams<{ id: string }>();

  useLayoutEffect(() => {
    getCourses(id).catch(console.error);
  }, [id]);

  return (
    <AppShell>
      <div className={'d-flex flex-column flex-grow-1'}>
        <Title>{t('labels.corsi')}</Title>

        <Container>
          {!courses ? (
            <FullscreenLoader fullscreen={false} />
          ) : !courses.length ? (
            <div className={'my-5'}>
              <h1 className={'text-page-title text-center'}>{t('courses.labels.noCorsi')}</h1>
            </div>
          ) : null}

          {!!courses?.length && !id && (
            <>
              <h1 className={'text-page-title text-center'}>{t('courses.labels.corsiDisponibili')}</h1>
              <HighlightedCard className="p-3">
                <p>{t('courses.labels.corsiDisponibiliDescrizione')}</p>
                <p>{t('courses.labels.corsiDisponibiliDescrizione2')}</p>
                <p className={'mb-0'}>{t('courses.labels.corsiDisponibiliDescrizione3')}</p>
              </HighlightedCard>
              {courses.map((course) => (
                <CourseBox key={course.id} course={course} />
              ))}
            </>
          )}

          {!!courses?.length && id && (
            <>
              <div className={`${styles.companyHeader} surface-card mb-5`}>
                <div className={styles.companyImage} style={{ backgroundImage: `url(${userCompanyData.logoUrl})` }} />
                <div className={styles.companyTitle}>{userCompanyData.name}</div>
              </div>
              {courses.map((course) => (
                <CourseBox key={course.id} course={course} />
              ))}
            </>
          )}
        </Container>

        <Footer />
      </div>
    </AppShell>
  );
};

export default CoursesComponent;
